class PickANom {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;
        let discountValue = 0;
        let discountName = '';
        let additionalDiscountValue = 0;
        let additionalDiscountCount = additionalDiscountValue / 10;
        let additionalDiscountName = '';
        let additionalMares = 0;
        let stallionValue = 0;
        let stallionName = '';
        let totalDiscountValue = discountValue + additionalDiscountValue;
        let discountedValue = stallionValue * (discountValue / 100);
        let rate = stallionValue - discountedValue;

        self.setAdditionalDiscount();
        self.setDiscount();
        self.setStallion();
    }

    setAdditionalDiscount() {
        let self = this;
        let prev = null;

        for (var i = 0; i < document.pickANom.additionalDiscount.length; i++) {
            document.pickANom.additionalDiscount[i].addEventListener('change', function() {
                if (this !== prev) {
                    prev = this;
                }

                if (self.discountValue == undefined) {
                    self.discountValue = 0;
                }

                if (self.stallionValue == undefined) {
                    self.stallionValue = 0;
                }

                self.additionalDiscountValue = this.value;
                self.additionalDiscountCount = this.value / 10;
                self.discountName = self.discountName;

                self.totalDiscountValue = Number(self.discountValue);

                self.discountedValue = self.stallionValue * (self.totalDiscountValue / 100);
                self.rate = self.stallionValue - self.discountedValue;
                self.additionalMareValue = self.rate * (self.additionalDiscountValue / 100);
                self.rate = self.rate - self.additionalMareValue;

                self.updateAdditionalDiscount(self.totalDiscountValue, self.discountName, self.additionalDiscountCount);
                self.updateRate(self.rate);
            });
        }
    }

    setDiscount() {
        let self = this;
        let prev = null;

        for (var i = 0; i < document.pickANom.discount.length; i++) {
            document.pickANom.discount[i].addEventListener('change', function() {
                if (this !== prev) {
                    prev = this;
                }

                if (self.additionalDiscountValue == undefined) {
                    self.additionalDiscountValue = 0;
                }

                if (self.additionalDiscountCount == undefined) {
                    self.additionalDiscountCount = 0;
                }

                if (self.stallionValue == undefined) {
                    self.stallionValue = 0;
                }

                self.discountValue = this.value;
                self.discountName = this.dataset.name;

                self.totalDiscountValue = Number(self.discountValue);

                self.discountedValue = self.stallionValue * (self.totalDiscountValue / 100);
                self.rate = self.stallionValue - self.discountedValue;
                self.additionalMareValue = self.rate * (self.additionalDiscountValue / 100);
                self.rate = self.rate - self.additionalMareValue;

                self.updateDiscount(self.totalDiscountValue, self.discountName, self.additionalDiscountCount);
                self.updateRate(self.rate);
            });
        }
    }

    setStallion() {
        let self = this;
        let prev = null;

        for (var i = 0; i < document.pickANom.stallion.length; i++) {
            document.pickANom.stallion[i].addEventListener('change', function() {
                if (this !== prev) {
                    prev = this;
                }

                if (self.additionalDiscountValue == undefined) {
                    self.additionalDiscountValue = 0;
                }

                if (self.additionalDiscountCount == undefined) {
                    self.additionalDiscountCount = 0;
                }

                if (self.discountValue == undefined) {
                    self.discountValue = 0;
                }

                self.stallionValue = this.value;
                self.stallionName = this.dataset.name;

                self.totalDiscountValue = Number(self.discountValue);

                self.discountedValue = self.stallionValue * (self.totalDiscountValue / 100);
                self.rate = self.stallionValue - self.discountedValue;
                self.additionalMareValue = self.rate * (self.additionalDiscountValue / 100);
                self.rate = self.rate - self.additionalMareValue;

                self.updateStallion(self.stallionName, self.stallionValue);
                self.updateRate(self.rate);
            });
        }
    }

    updateAdditionalDiscount(total, name, count) {
        document.getElementById('discountValue').innerHTML = total+'% Discount';
        document.getElementById('discountCount').innerHTML = count;
        document.getElementById('discountExpress').value = name+' + '+count+' Additional mares';
        document.getElementById('discountFormInputLabelSpanCount').innerHTML = count;
    }

    updateDiscount(total, name, count) {
        document.getElementById('discountValue').innerHTML = total+'% Discount';
        document.getElementById('discountName').innerHTML = name+' + <strong><span id="discountCount">'+count+'</span></strong> Additional mares';
        document.getElementById('discountExpress').value = name+' + '+count+' Additional mares';
        document.getElementById('discountFormInputLabelSpan').innerHTML = name+' + <strong><span id="discountFormInputLabelSpanCount">'+count+'</span></strong> Additional mares';
    }

    updateRate(rate) {
        document.getElementById('rateValue').innerHTML = '£'+rate+' + VAT';
        document.getElementById('rateExpress').value = '£'+rate+' + VAT';
        document.getElementById('rateFormInputLabelSpan').innerHTML = '£'+rate+' + VAT';
    }

    updateStallion(name, value) {
        document.getElementById('stallionValue').innerHTML = '£'+value;
        document.getElementById('stallionName').innerHTML = name;
        document.getElementById('stallionExpress').value = name;
        document.getElementById('stallionFormInputLabelSpan').innerHTML = name;
    }
}

export default PickANom;
